<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              Enter your name below so {{ owner }} knows who can cover their
              shift.
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <DSInput v-model="acceptName" placeholder="Full Name"></DSInput>
              <br />
              <DSInput
                v-model="acceptPhone"
                pattern="number"
                type="tel"
                :unformatter="value => value.replace(/[^\d]/g, '')"
                :formatter="value => value.replace(/[^\d]/g, '')"
                placeholder="Mobile Number"
              ></DSInput>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <DSButton class="cancel" type="secondary" @click="close"
                >Cancel</DSButton
              >
              <DSButton class="submit" type="primary" @click="submit"
                >Submit</DSButton
              >
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AcceptModal',
  props: {
    owner: {
      type: String,
      default: 'Shift Owner',
    },
  },
  data() {
    return {
      acceptName: '',
      acceptPhone: '',
      test: '',
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    submit() {
      console.log('submit: ', this.acceptName, this.acceptPhone);
      this.$emit('submit', this.acceptName, this.acceptPhone);
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-header,
.modal-body,
.modal-footer {
  padding: 10px;
  border: none;
}
</style>
